import { Vacation } from '@thehubz/client/data-access-api';
import { areIntervalsOverlapping } from 'date-fns';

/**
 * Get the out of office message for the user if they are on vacation today.
 * Message will be in the following format:
 * `[Out of office 18.08.2021 - 20.08.2021]`
 *
 * @param vacations
 * @returns Out of office message
 */
export function getOOOMessage(vacations: Vacation[]): string {
  const today = new Date();
  let outOfOfficeMessage = '';
  vacations.some((vacation) => {
    const vacationStart = new Date(vacation.from);
    const vacationEnd = new Date(vacation.to);
    if (today >= vacationStart && today <= vacationEnd) {
      outOfOfficeMessage = `[Out of office ${vacationStart.toLocaleDateString()} - ${vacationEnd.toLocaleDateString()}]`;
    }
    return outOfOfficeMessage !== '';
  });

  return outOfOfficeMessage;
}

/**
 * Get the out of office message for the user if they are on vacation today.
 * Message will be in the following format:
 * `[Out of office 18.08.2021 - 20.08.2021]`
 *
 * @param vacations
 * @param startDate
 * @param endDate
 * @returns Out of office message
 */
export function getOOOMessageForDateRange(vacations: Vacation[], startDate: Date, endDate: Date): string {
  let outOfOfficeMessage = '';
  vacations.some((vacation) => {
    const vacationStart = new Date(vacation.from);
    const vacationEnd = new Date(vacation.to);
    if (
      areIntervalsOverlapping(
        { start: startDate, end: endDate },
        { start: vacationStart, end: vacationEnd },
        {
          inclusive: true,
        },
      )
    ) {
      outOfOfficeMessage = `[Out of office ${vacationStart.toLocaleDateString()} - ${vacationEnd.toLocaleDateString()}]`;
    }
    return outOfOfficeMessage !== '';
  });

  return outOfOfficeMessage;
}
